module.exports = __webpack_public_path__ + "media/logos/dobry-wzor-laureat-raport@2x-d3127e73.png";